import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  const checkApproveAllButton = () => {
    const numberOfItems = $('.approve-billable-item-link--approve').length;
    $('.approve-all-billable-items-link').removeClass('approve-all-billable-items-link--selected');
    if (
      $('.approve-billable-item-link--approve.approve-billable-item-link--selected').length ===
      numberOfItems
    ) {
      $('.approve-all-billable-items-link').addClass('approve-all-billable-items-link--selected');
    }
  };

  checkApproveAllButton();

  const toogleApproveSingleItem = (quoteItemId, isApproved) => {
    // select columns for mobile and desctop view
    const $columns = $(`[data-billable-item-id='${quoteItemId}']`);
    const $tr = $columns.closest('.quote-page-item');
    const $mobileItem = $columns.closest('.mobile-quote-page-item');

    $columns
      .find('.approve-billable-item-link')
      .removeClass('approve-billable-item-link--selected');
    if (isApproved) {
      $columns
        .find('.approve-billable-item-link--approve')
        .addClass('approve-billable-item-link--selected');
    } else {
      $columns
        .find('.approve-billable-item-link--disapprove')
        .addClass('approve-billable-item-link--selected');
    }

    $tr.toggleClass('quote-page-item--disapproved', !isApproved);
    $mobileItem.toggleClass('mobile-quote-page-item--disapproved', !isApproved);
  };

  $(document).on('click', '#quote .approve-billable-item-link:not(.login-required)', (e) => {
    // Use currentTarget (the matched link) not target — the tooltip text is
    // nested inside the link, so clicking it would otherwise bypass these checks.
    const $link = $(e.currentTarget);

    if (
      $link.hasClass('approve-billable-item-link--selected') ||
      $link.hasClass('approve-billable-item-link--locked')
    ) {
      return false;
    }

    const $parent = $link.closest('.content-block--billable');
    const quoteId = $parent.data().billableId;

    const $td = $link.parents(['td', '.mobile-quote-page-item__col']);
    const quoteItemId = $td.data().billableItemId;
    const isApproved = $link.hasClass('approve-billable-item-link--approve');

    $.post(`/quotes/${quoteId}/quote_items/${quoteItemId}/xhr_toggle_approved`, (data) => {
      toogleApproveSingleItem(quoteItemId, isApproved);
      if (data.children_items) {
        data.children_items.forEach((itemId) => {
          toogleApproveSingleItem(itemId, isApproved);
        });
      }
      $('.billable-total-block__subtotal').text(data.subtotal);
      $('.billable-total-block__tax').text(data.tax_amount);
      $('.billable-total-block__shipping').text(data.shipping);
      $('.billable-total-block__total-value').text(data.total);
      $('.approve-quote-total').text(data.total);
      $('.invoice-summary__balance-owing-total').text(data.total);
      $('.approve-quote-count').text(
        `${data.approved_count} ${data.approved_count === 1 ? 'item' : 'items'}`
      );
      checkApproveAllButton();
    });

    return false;
  });

  $(document).on('click', '#quote .approve-all-billable-items-link:not(.login-required)', (e) => {
    // currentTarget (the matched link), not target — the tooltip text is nested
    // inside the link, so clicking it would otherwise bypass the locked check.
    const $link = $(e.currentTarget);
    if ($link.hasClass('approve-all-billable-items-link--locked')) {
      return false;
    }

    const $parent = $link.closest('.content-block--billable');
    const quoteId = $parent.data().billableId;

    $.post(`/quotes/${quoteId}/quote_items/xhr_toggle_approved`, (data) => {
      $('.billable-total-block__subtotal').text(data.subtotal);
      $('.billable-total-block__tax').text(data.tax_amount);
      $('.billable-total-block__shipping').text(data.shipping);
      $('.billable-total-block__total-value').text(data.total);
      $('.approve-quote-total').text(data.total);
      $('.invoice-summary__balance-owing-total').text(data.total);
      $('.approve-quote-count').text(
        `${data.approved_count} ${data.approved_count === 1 ? 'item' : 'items'}`
      );
      $('.approve-billable-item-link').removeClass('approve-billable-item-link--selected');
      if ($link.hasClass('approve-all-billable-items-link--selected')) {
        $('.approve-billable-item-link--disapprove').addClass(
          'approve-billable-item-link--selected'
        );
        $('.quote-page-item').addClass('quote-page-item--disapproved');
        $('.mobile-quote-page-item').addClass('mobile-quote-page-item--disapproved');
      } else {
        $('.approve-billable-item-link--approve').addClass('approve-billable-item-link--selected');
        $('.quote-page-item').removeClass('quote-page-item--disapproved');
        $('.mobile-quote-page-item').removeClass('mobile-quote-page-item--disapproved');
      }
      checkApproveAllButton();
    });

    return false;
  });
});
